import { GraphService } from "../../../graphql/services/graph.service";
import { ToastService } from "../../../tools/message/service/toast.service";
import { ListItemMutator } from "../../baseListing/helpers/list-item-mutator";
import { TableRowRefModel } from "../models/table-row-ref.model";

export class TableRowMutator extends ListItemMutator {
  constructor(graphService: GraphService, rowRef: TableRowRefModel, messageService: ToastService) {
    super(graphService, rowRef, messageService);
  }
}
